import { ItemArgs } from "@progress/kendo-angular-dropdowns";
import { IBase, IBaseSearchRequest } from "src/app/core/models/base";
import { ICompany } from "./company";

export interface IEmployee extends IBase {
    id: string,
    userName: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber?: string,
    language: Language,
    role?: string,
    userId: string,
    company?: ICompany;
    fullName?: string,
  }

  export interface IEditUser extends ICreateUserRequest{
    id: string,
  }

  export class EditUser implements IEditUser{
    id = null;
    userName = '';
    firstName = '';
    lastName = '';
    email = '';
    phoneNumber? = '';
    language = 0;
    password? = '';
    role? = '';
    companyId = null;
  }

  export interface ICreateUserRequest {
    userName: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber?: string,
    language: Language,
    password?: string,
    role?: string,
    companyId: string
  }

  export interface IUpdateUserRequest {
    id: string,
    firstName: string,
    lastName: string,
    phoneNumber?: string,
    language: Language,
    role: string,
  }

  

  export interface IUserRole {
    roleId: string;
    roleName: string;
    description: string;
    enabled: string;
  }

  export interface IListRolesRequest {
    userId: string,
    showRootRoles: boolean,
  }

  export interface IUserRoleRequest{
    employeeRoles: IUserRole[];
  }

  export interface ISearchUserRquest extends IBaseSearchRequest{
    isActive?: boolean,
  }

  export enum Language{
    german = 0,
    french = 1
  }

  export interface IGetEmployeesRequest extends IBaseSearchRequest {
    companyId?: string
  }